import { Grid, Flex, AspectRatio, Box } from "@chakra-ui/react";
import { Image } from "components";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import { Content } from "modules/storyblok/adapters";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ContentWithImageProps } from "./ContentWithImage.d";
import { richTextStyles } from "./ContentWithImage.styles";

export const ContentWithImage = ({
  srcMobile,
  srcDesktop,
  alt,
  reverseColumns = false,
  components,
  bgMobile,
  isIllustration = false,
  illustrationSizeMobile = "128px",
  illustrationAlignMobile = "start",
  ptMobile = "12",
  ptTablet = "12",
  ptDesktop = "12",
  pbMobile = "12",
  pbTablet = "12",
  pbDesktop = "12",
  px = "4",
  sbEditable,
}: SbEditableComponentProps<ContentWithImageProps>) => {
  const columnOrder = reverseColumns ? { base: 0, md: -1 } : 0;

  const bg = { base: bgMobile ? "greyscale.200" : "transparent", md: "transparent" };
  const imageMaxWidth = isIllustration ? { base: illustrationSizeMobile, md: "512px" } : "full";

  return (
    <Box bg={bg} width="full" {...sbEditable}>
      <Grid
        maxWidth={MAX_GRID_WIDTH}
        mx="auto"
        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
        alignItems="center"
        pt={{ base: ptMobile, md: ptTablet, lg: ptDesktop }}
        pb={{ base: pbMobile, md: pbTablet, lg: pbDesktop }}
        px={px}
        gap={{ base: 1, md: 4, xl: 8 }}
      >
        <AspectRatio
          ratio={1}
          justifySelf={{ base: illustrationAlignMobile, md: "left" }}
          width="100%"
          maxWidth={imageMaxWidth}
        >
          <Image srcDesktop={srcDesktop} srcMobile={srcMobile} alt={alt} />
        </AspectRatio>

        <Flex order={columnOrder} direction="column" alignItems="flex-start">
          {components.map((component) =>
            component.component === "content" ? (
              <Content key={component._uid} blok={{ richTextStyles, ...component }} />
            ) : (
              <DynamicComponent key={component._uid} blok={component} />
            )
          )}
        </Flex>
      </Grid>
    </Box>
  );
};
